import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import TDDepartmentsFilter from '../../../components/filters/TDDepartmentsFilter';
import TDUnitsFilter from '../../../components/filters/TDUnitsFilter';
import TDLinkTabs from '../../../components/linkTabs/TDLinkTabs';
import PageTitleWithTooltip from '../../../components/pageTitleWithTooltip/PageTitleWithTooltip';
import PageWithHeader from '../../../layouts/pageWithHeader/PageWithHeader';
import { useAnalysis } from '../../../utils/contexts/AnalysisContext';
import ClassProgressTooltip from './classProgressTooltip/ClassProgressTooltip';
import useClassProgress from './useClassProgress';

const ClassProgress = () => {
  const { t } = useTranslation();
  const { tabs, currentTab, onChangeTab } = useClassProgress();
  const { ANALYSIS_SEGMENT } = useAnalysis();

  return (
    <PageWithHeader
      left={
        <PageTitleWithTooltip
          title={t('class_progress')}
          testId='class-progress-page-heading'
        />
      }
      center={<TDLinkTabs links={tabs} onChange={onChangeTab} />}
      right={
        currentTab === tabs[0]?.name ? (
          <TDUnitsFilter />
        ) : (
          <TDDepartmentsFilter />
        )
      }
      tooltip={<ClassProgressTooltip />}
      pageName={ANALYSIS_SEGMENT.PAGE_NAMES.Class_Page}
    >
      <Outlet />
    </PageWithHeader>
  );
};

export default ClassProgress;
